export default "__VITE_ASSET__458001b8__"